import React from 'react'
import styled from 'styled-components/macro'
import { getGelTokens } from '@tal-gel/theming'

import { Title, Text } from './Components'

const Component = styled.div`
  padding: 56px 24px;
  background-color: ${() => getGelTokens().brand.brandColorGrayT05};

  @media only screen and (min-width: 768px) {
    padding: 100px 39px;
    display: flex;
    justify-content: center;
  }
`

const InnerContent = styled.div`
  max-width: 900px;
  text-align: center;
`

const Link = styled.a`
  font-weight: bold;
  color: ${() => getGelTokens().brand.brandColorPrimary1};
  text-decoration: none;

  &:hover {
    cursor: pointer;
    filter: brightness(110%);
    text-decoration: underline;
  }

  &:focus,
  &:visited,
  &:active {
    color: ${() => getGelTokens().brand.brandColorPrimary1};
    text-decoration: none;
  }
`

const Note = () => {
  return (
    <Component>
      <InnerContent>
        <Title>A note about your data</Title>
        <Text bold>
          Your privacy is important to us. Rest assured, the information
          collected through the TAL Health Scout quiz will be stored securely,
          and only used to generate your health check recommendations. For more
          information please refer to our <Link href=''>Terms of Use</Link>.
        </Text>
      </InnerContent>
    </Component>
  )
}

export default Note
